export type ProcessingStatus =
  | "QUEUED"
  | "DATA_LOAD_RUNNING"
  | "DATA_LOAD_FAILED"
  | "CATEGORY_CLASSIFICATION_RUNNING"
  | "CATEGORY_CLASSIFICATION_FAILED"
  | "SHORT_SUMMARIZATION_RUNNING"
  | "SHORT_SUMMARIZATION_FAILED"
  | "CATEGORY_SUMMARIZATION_RUNNING"
  | "CATEGORY_SUMMARIZATION_FAILED"
  | "PROBLEM_CLASSIFICATION_RUNNING"
  | "PROBLEM_CLASSIFICATION_FAILED"
  | "VIEW_DATA_REFRESH_RUNNING"
  | "VIEW_DATA_REFRESH_FAILED"
  | "RAG_INDEXING_RUNNING"
  | "RAG_INDEXING_FAILED"
  | "COMPLETED";

export class Analysis {
  constructor(
    public readonly id: string,
    public readonly title: string,
    public readonly startDate: Date,
    public readonly endDate: Date,
    public readonly period: string | null,
    public readonly status: ProcessingStatus,
    public readonly categoryTreeId: string,
    public readonly startedAt: Date,
    public readonly totalVocCharCount: number | null,
  ) {}

  get year(): number {
    return this.startDate.getFullYear();
  }

  get month(): number {
    return this.startDate.getMonth() + 1;
  }
}
